export const POLLING_INTERVAL = 5000;
export const ALERT_ANIMATION_TIME_PERIOD = 1000;
export const WAIT_TIME_POLLING_INTERVAL = 30000;
